import { GET_USERS, GET_USERS_DETAILS, RESET_USER_DETAILS } from '../actionTypes';

const initialState = {
  users: [],
  userDetails: null
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        users: action.payload
      };
    case GET_USERS_DETAILS:
      return {
        ...state,
        userDetails: action.payload
      };
    case RESET_USER_DETAILS:
      return {
        ...state,
        userDetails: null
      };
    default: {
      return state;
    }
  }
};

export default usersReducer;
